import React from 'react';
import BackButton from '../components/BackButton';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

const Sustainability = () => {
  return (
    <>
      <main className="flex-grow w-full max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop pb-12 md:pb-16 pt-28 md:pt-32">
        <BackButton />
        <Reveal>
        <div className="max-w-3xl mx-auto">
          <header className="mb-12 text-center">
            <h1 className="font-display-lg text-display-lg-mobile md:text-[40px] text-primary mb-4">Sustainability Commitment</h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant">Protecting your water and the environment.</p>
          </header>
          
          <div className="bg-surface-container-lowest rounded-2xl p-8 md:p-12 border border-outline-variant/30 shadow-[0_8px_30px_rgba(0,0,0,0.04)] space-y-8">
            <section>
              <h2 className="font-headline-md text-headline-md text-on-surface mb-4 flex items-center gap-2">
                <span className="material-symbols-outlined text-primary">eco</span>
                Eco-Friendly Practices
              </h2>
              <p className="text-on-surface-variant font-body-md leading-relaxed mb-4">
                TankCare is dedicated to using eco-friendly, non-toxic sanitization methods that protect both your aquatic environments and the broader ecosystem. We prioritize solutions that minimize water waste while ensuring a pristine clean.
              </p>
              <p className="text-on-surface-variant font-body-md leading-relaxed">
                By investing in high-efficiency equipment and continuous training, we ensure our carbon footprint remains small without compromising the premium quality of our service.
              </p>
            </section>
          </div>
        </div>
        </Reveal>
      </main>
      
      {/* Footer */}
      <Footer />
    </>
  );
};

export default Sustainability;
